import { render, staticRenderFns } from "./DisplayProduct.vue?vue&type=template&id=cd288ff4"
import script from "./DisplayProduct.vue?vue&type=script&lang=js"
export * from "./DisplayProduct.vue?vue&type=script&lang=js"
import style0 from "./DisplayProduct.vue?vue&type=style&index=0&id=cd288ff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports